import { initialState } from '../state';
import { BpmnProcessActions, BpmnProcessCreatorActionTypes } from '../actions';

export function bpmnXml(state = initialState.bpmnXml, action: BpmnProcessActions): string {
  switch (action.type) {
    case BpmnProcessCreatorActionTypes.GENERATE_BPMN_XML_SUCCESS: {
      return  action.payload.bpmnXml;
    }
    default: {
      return state;
    }
  }
}
